import { render, staticRenderFns } from "./SetReach.vue?vue&type=template&id=288bb2b0"
import script from "./SetReach.vue?vue&type=script&lang=js"
export * from "./SetReach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports